module.exports = __webpack_public_path__ + "static/media/Tarjetas.d7d56a81.png";